module.exports = __webpack_public_path__ + "media/icons/border-right-7766a84a.png";